module.exports = __webpack_public_path__ + "img/background_2.479e5e07.png";